import { connect, ConnectedProps } from 'react-redux';
import { RootState } from '../../../../../../../../store/root-reducer';
// eslint-disable-next-line import/no-cycle
import BillingSummaryModal from './billing-summary-modal';
import {
  ApplyCouponCodeRequest,
  ModifySubscriptionRequest,
  Plan,
  PurchaseModifySubscriptionRequest,
  PurchaseSubscriptionRequest,
} from '../../../../types';
import {
  applyCouponCodeRequest,
  modifyInboxAnalyzerSubscriptionRequest,
  purchaseInboxAnalyzerModifySubscriptionRequest,
  purchaseSubscriptionRequest,
} from '../../../../extra-actions';
import {
  deleteAppliedCouponCode,
  resetHandleSubscriptionResponse,
  resetSubscription,
} from '../../../../billing-subscription-slice';
import { getAdminSettingsRequest } from '../../../../../admin-settings/extra-actions';

const mapStateToProps = (state: RootState) => ({
  getAdminSettingsRequestStatus:
    state.adminSettings.getAdminSettingsRequest.status,
  getAdminSettingsRequestMessage:
    state.adminSettings.getAdminSettingsRequest.message,
  getAdminSettingsRequestError:
    state.adminSettings.getAdminSettingsRequest.error,

  sendPurchaseInboxAnalyzerSubscriptionRequestStatus:
    state.billingAndSubscription.purchaseInboxAnalyzerSubscriptionRequest
      .status,
  sendPurchaseInboxAnalyzerSubscriptionRequestError:
    state.billingAndSubscription.purchaseInboxAnalyzerSubscriptionRequest.error,
  sendPurchaseInboxAnalyzerSubscriptionRequestMessage:
    state.billingAndSubscription.purchaseInboxAnalyzerSubscriptionRequest
      .message,

  sendGetConnectedUsersAndEmailAccountsRequestError:
    state.billingAndSubscription.getConnectedUsersAndEmailAccountsRequest.error,
  sendGetConnectedUsersAndEmailAccountsRequestResponse:
    state.billingAndSubscription.getConnectedUsersAndEmailAccountsResponse,

  sendApplyCouponCodeRequestStatus:
    state.billingAndSubscription.applyCouponCodeRequest.status,
  sendApplyCouponCodeRequestMessage:
    state.billingAndSubscription.applyCouponCodeRequest.message,
  isSendApplyCouponCodeRequestError:
    state.billingAndSubscription.applyCouponCodeRequest.error?.error,
  getCouponCodeResponse: state.billingAndSubscription.applyCouponCodeResponse,

  sendGetInboxAnalyzerModifySubscriptionRequestStatus:
    state.billingAndSubscription.modifyInboxAnalyzerSubscriptionRequest.status,
  sendGetInboxAnalyzerModifySubscriptionRequestError:
    state.billingAndSubscription.modifyInboxAnalyzerSubscriptionRequest.error,
  sendGetModifySubscriptionResponse:
    state.billingAndSubscription.modifySubscriptionResponse,
  sendGetPurchaseInboxAnalyzerModifySubscriptionRequestStatus:
    state.billingAndSubscription.purchaseInboxAnalyzerModifySubscriptionRequest
      .status,

  sendGetHandleSubscriptionResponse:
    state.billingAndSubscription.handleSubscriptionResponse,
  sendGetHandleSubscriptionRequestError:
    state.billingAndSubscription.handleSubscriptionRequest.error,
  sendGetHandleSubscriptionRequestStatus:
    state.billingAndSubscription.handleSubscriptionRequest.status,

  sendGetInboxAnalyzerCalculatePayRequestStatus:
    state.billingAndSubscription.calculateInboxAnalyzerPayRequest.status,
  sendGetInboxAnalyzerCalculatePayResponse:
    state.billingAndSubscription.getCalculateInboxAnalyzerPayResponse,

  couponCodeDiscount:
    state.billingAndSubscription.applyCouponCodeResponse?.discountValue,
  couponCodeDiscountType:
    state.billingAndSubscription.applyCouponCodeResponse?.discountType,
  sendGetAccountSubscriptionResponse:
    state.billingAndSubscription.getAccountSubscriptionResponse,
  currentPlanName: state.home?.subscription?.planName,
  currentPlanCode: state.home?.subscription?.planCode,
  hasAccountSubscription: state.home?.subscription?.customerId,
  isValidUser: state.home?.signup_date,
  adminSettings: state.adminSettings?.adminSettings,
});

const mapDispatchToProps = {
  sendGetAdminDetailsRequest: () => getAdminSettingsRequest(),
  sendPurchaseSubscriptionRequest: (payload: PurchaseSubscriptionRequest) =>
    purchaseSubscriptionRequest(payload),
  resetSubscription: () => resetSubscription(),
  resetHandleSubscriptionResponse: () => resetHandleSubscriptionResponse(),
  sendApplyCouponCodeRequest: (payload: ApplyCouponCodeRequest) =>
    applyCouponCodeRequest(payload),
  deleteAppliedCouponCode: () => deleteAppliedCouponCode(),
  sendInboxAnalyzerModifySubscriptionRequest: (
    payload: ModifySubscriptionRequest,
  ) => modifyInboxAnalyzerSubscriptionRequest(payload),
  sendPurchaseInboxAnalyzerModifySubscriptionRequest: (
    payload: PurchaseModifySubscriptionRequest,
  ) => purchaseInboxAnalyzerModifySubscriptionRequest(payload),
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type IProps = ConnectedProps<typeof connector> & {
  show: boolean;
  onClose: VoidFunction;
  selectedPlanDetails: Plan | null;
  isUserModifyingSubscription: boolean;
  onPurchase: (token: string, couponCode: string) => void;
  isAnnuallyCycle: boolean;
};

export default connector(BillingSummaryModal);
